import { render, staticRenderFns } from "./modal-new-user-welcome.vue?vue&type=template&id=2ee39998&scoped=true&"
import script from "./modal-new-user-welcome.vue?vue&type=script&lang=js&"
export * from "./modal-new-user-welcome.vue?vue&type=script&lang=js&"
import style0 from "./modal-new-user-welcome.vue?vue&type=style&index=0&id=2ee39998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee39998",
  null
  
)

export default component.exports